<template>
  <div>
    <page-title
      :heading="`${isTambah ? 'Tambah' : 'Ubah'} Bahan Habis Pakai`"
      :breadcrumb="[
        {
          label: 'Manajemen Obat & BHP',
          link: '/manajemen-obat-bhp'
        },
        {
          label: `${isTambah ? 'Tambah' : 'Ubah'} Obat & BHP`,
          active: true
        }
      ]"
      class="layout-gantung ninja-shadow custom-breadcrumb"
    />
    <div class="container-fluid __zoom_display">
      <div class="card card-box mb-3 ninja-shadow">
        <div class="card-body p-5">
          <!-- FORM -->
          <b-row
            v-for="(bhp, index) in $v.bhpList.$each.$iter"
            :key="index"
          >
            <b-col sm="11 outer-bhp" :class="{'mt-5': index > 0}">
              <b-row>
                <b-col sm="6">
                  <!-- kode bhp -->
                  <b-form inline class="pb-3">
                    <label
                      class="col-md-3"
                      >Kode BHP <span style="color:red">*</span></label
                    >
                    <b-form-input
                      id="inline-form-input-kode"
                      placeholder="input kode BHP"
                      :value="bhpList[index].kode_layanan"
                      class="col-md-7"
                      :class="{
                        'is-invalid': bhp.kode_layanan.$error
                      }"
                      @input="setKodeBhp(index, $event)"
                    ></b-form-input>
                    <small
                      v-if="bhp.kode_layanan.$error"
                      class="form-text invalid-feedback"
                      >{{ setErrorMessage("Kode BHP", bhp.kode_layanan) }}</small
                    >
                  </b-form>
                  <!-- nama bhp -->
                  <b-form inline class="pb-3">
                    <label
                      class="col-md-3"
                      >Nama BHP <span style="color:red">*</span></label
                    >
                    <b-form-input
                      placeholder="input nama BHP"
                      class="col-md-7"
                      :class="{
                        'is-invalid': bhp.nama_layanan.$error
                      }"
                      :value="bhpList[index].nama_layanan"
                      @input="setNamaBhp(index, $event)"
                    ></b-form-input>
                    <small
                      v-if="bhp.nama_layanan.$error"
                      class="form-text invalid-feedback"
                      >{{
                        setErrorMessage("Nama BHP", bhp.nama_layanan)
                      }}</small
                    >
                  </b-form>
                  <!-- Harga -->
                  <b-form inline class="pb-3">
                    <label
                      class="col-md-3"
                      >Harga <span style="color:red">*</span></label
                    >
                    <money
                      id="inline-form-input-tarif"
                      class="form-control col-md-7"
                      v-model="bhp.tarif.$model"
                      v-bind="money"
                      @input="parseHarga(index, bhp.tarif.$model)"
                    ></money>
                    <small
                      v-if="bhp.tarif.$error"
                      class="form-text invalid-feedback"
                      >{{
                        setErrorMessage("Harga", bhp.tarif.$model)
                      }}</small
                    >
                  </b-form>
                </b-col>
                  <b-col sm="6">
                    <!-- stok -->
                    <b-form inline>
                      <label
                        class="col-md-3"

                        >Stok</label
                      >
                      <b-form-input
                        v-model="bhpList[index].stok"
                        @change="
                          onChangeValue({
                            label: 'stok',
                            index,
                            $event
                          })
                        "
                        style="padding-right : 30px"
                        v-on:keypress="NumbersOnly"
                        maxlength="100"
                        class="col-md-7 pl-2"
                        placeholder="input stok"
                        :disabled="!stockIsEdit && isEdit"
                      ></b-form-input>
                      <span v-if="!stockIsEdit && isEdit" @click="enableEdit()" style="padding-left: 10px; cursor: pointer;">
                            <font-awesome-icon icon="pencil-alt" />
                        </span>
                    </b-form>
                    <!-- satuan -->
                    <b-form inline>
                      <label
                        class="col-md-3"

                        >Satuan</label
                      >
                      <vue-select
                        style="font-size:13px"
                        :options="optSatuan"
                        v-model="bhpList[index].satuan_id"
                        class="form-select-tarif col-md-7 p-0 mt-3"
                        placeholder="pilih satuan"
                        :disabled="!stockIsEdit && isEdit"
                      />
                    </b-form>
                    <!-- catatan -->
                    <b-form inline>
                      <label
                        class="col-md-3"

                        >Catatan</label
                      >
                        <b-form-textarea
                          :disabled="!stockIsEdit && isEdit"
                          class="col-md-8 mt-3"
                          rows="4" no-resize
                          v-model="bhpList[index].note"
                          @change="
                            onChangeValue({
                              label: 'note',
                              index,
                              $event
                            })
                          "
                          placeholder="input catatan pendukung.
Contoh: Masa berlaku bhp
20 September 2025, pembelian batch 1."
                        ></b-form-textarea>
                    </b-form>
                  </b-col>
              </b-row>
            </b-col>
            <!-- action minus -->
            <b-col sm="1" style="margin-top: 80px;">
              <div align="right">
                <b-button
                  variant="danger"
                  v-if="isTambah && index > 0"
                  :style="btnRemoveMobileStyle"
                  @click="removeBhp(index)"
                >
                  <font-awesome-icon icon="minus" class="fa-sm" />
                </b-button>
              </div>
            </b-col>
          </b-row>
          <!-- END FORM -->
          <b-row class="d-flex align-items-center ">
            <b-col lg="11 p-0">
              <div class="d-flex justify-content-center mt-4">
                <b-button
                  v-if="isTambah"
                  style="padding: .4rem .7rem; background: #42abdc; color: white; border: 2px solid #42abdc;  border-radius: 100%"
                  @click="addBhp"
                >
                  <font-awesome-icon icon="plus" />
                </b-button>
              </div>
              <div align="right">
                <b-button
                  class="text-capitalize mr-2"
                  variant="danger"
                  :to="{ name: 'klinik-list-bhp' }"
                  >Keluar</b-button
                >
                <b-button
                  class="text-capitalize"
                  variant="primary"
                  @click="saveBhp()"
                  >Simpan</b-button
                >
              </div>
            </b-col>
          </b-row>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import { library } from "@fortawesome/fontawesome-svg-core";
import { required, minLength, maxLength } from "vuelidate/lib/validators";
import { Money } from "v-money";
import debounce from "lodash/debounce";

import {
  faCopy,
  faDownload,
  faUpload,
  faPlus,
  faMinus,
  faPencilAlt
} from "@fortawesome/free-solid-svg-icons";

library.add(faCopy, faUpload, faDownload, faPlus, faMinus, faPencilAlt);

// custom validation
const charVal = value => {
  const regex = new RegExp("^([0-9a-zA-Z-]*)$");
  return regex.test(value);
};

const duplicate = function(value, bhp) {
  const bhpList = this.$v.bhpList.$model,
    bhpTotal = bhpList.length,
    key = Object.keys(bhp).find(key => bhp[key] === value);

  if (bhpTotal <= 1) return true;

  const bhpIndex = this.bhpList.findIndex(bhp => bhp[key] === value);

  const isDuplicate = [...bhpList]
    .splice(bhpIndex + 1, bhpTotal - 1)
    .some(val => {
      return value == val[key];
    });

  return !isDuplicate;
};

const duplicateBe = async function(value, bhp) {
  let key = Object.keys(bhp).find(key => bhp[key] === value);
  if (value == "" || value == null) return true;
  if (
    this.isEdit &&
    value == (key == "kode_layanan" ? this.prevKodeBhp : this.prevNamaBhp)
  )
    return true;
  let response = await this.$axios.get(
    `klinik/bhp/cek?id=${this.bhp_id}&klinik_id=${this.getKlinikId}&kategori_id=3&${key}=${value}`
  );
  return response.data.status;
};

export default {
  name: "listBhp",
  components: { 
    Money,
    "vue-select": () => import("@/components/VueSelect.vue")
   },
  data() {
    return {
      bhp_id: null,
      bhpCount: 2,
      bhpList: [
        {
          klinik_id: this.$store.getters.getKlinikId,
          kode_layanan: null,
          kategori_id: 3,
          nama_layanan: null,
          tarif: 0,
          stok: null,
          satuan_id: null,
          note: null,
        }
      ],
      beingSubmit: false,
      prevKodeBhp: "",
      prevNamaBhp: "",
      optSatuan: [],

      // v-money
      money: {
        decimal: ".",
        thousands: ",",
        prefix: "Rp ",
        suffix: "",
        precision: 0
      },
      stockIsEdit: false,
    };
  },
  validations: {
    bhpList: {
      $each: {
        kode_layanan: {
          required,
          minLength: minLength(3),
          maxLength: maxLength(10),
          charVal,
          duplicate,
          duplicateBe
        },
        kategori_id: {},
        nama_layanan: {
          required,
          maxLength: maxLength(100),
          duplicate,
          duplicateBe
        },
        tarif: {}
      }
    }
  },
  computed: {
    btnRemoveMobileStyle() {
      if (this.isMobile()) {
        return {
          padding: ".4rem .7rem",
          "border-radius": "100%",
          "margin-left": "-22px"
        };
      }

      return {
        padding: ".5rem .8rem",
        "border-radius": "100%",
        "margin-left": "-8px"
      };
    },
    ...mapGetters(["getKlinikId"]),
    isTambah() {
      return this.bhp_id ? false : true;
    },
    isEdit() {
      return !this.isTambah;
    }
  },
  beforeRouteLeave(to, from, next) {
    if (!this.beingSubmit && localStorage.getItem("IDLE") != 1) {
      this.$swal({
        title: "Keluar",
        html: `Apakah Anda yakin untuk keluar dari halaman ini?<br>Data yang telah ditulis tidak akan tersimpan.`,
        type: "warning",
        showCancelButton: true,
        cancelButtonText: "Tidak",
        confirmButtonText: "Ya"
      }).then(res => {
        if (res.value) {
          next();
        } else {
          next(false);
        }
      });
    } else {
      next();
    }
  },
  created() {
    this.bhp_id = this.$router.currentRoute.params.id || "";
    this.getSatuan();

    if (this.isEdit) {
      this.$axios
        .get(
          `klinik/bhp/${this.bhp_id}?klinik_id=${this.getKlinikId}`
        )
        .then(res => {
          let { status, data } = res.data;
          let {
            klinik_id,
            nama_layanan,
            kode_layanan,
            kategori_id,
            tarif,
            stok,
            satuan,
            note
          } = data.bhp;

          let selectedSatuan = {}

          if(satuan != null){
            selectedSatuan = {
              label: satuan.name,
              value: satuan.id
            }
          }
          

          if (status) {
            this.bhpList[0].tarif = tarif;
            this.bhpList[0].klinik_id = klinik_id;
            this.bhpList[0].kode_layanan = this.prevKodeBhp = kode_layanan;
            this.bhpList[0].nama_layanan = this.prevNamaBhp = nama_layanan;
            this.bhpList[0].kategori_id = kategori_id;
            this.bhpList[0].stok = stok == null ? '-' : stok;
            this.bhpList[0].satuan_id = selectedSatuan;
            this.bhpList[0].note = note;
            return tarif;
          }
        });
    }
  },
  methods: {
    setKodeBhp: debounce(function(index, value) {
      this.bhpList[index].kode_layanan = value;
      this.$v.bhpList.$each[index].kode_layanan.$touch();
    }, 500),
    setNamaBhp: debounce(function(index, value) {
      this.bhpList[index].nama_layanan = value;
      this.$v.bhpList.$each[index].nama_layanan.$touch();
    }, 500),
    parseHarga(index, val = "Rp 0") {
      val = typeof val == "number" ? val.toString() : val;
      let rawHarga = val.indexOf(" ") >= 0 ? val.split(" ")[1] : val,
        harga = rawHarga.replace(/[,]+/g, "");
      this.bhpList[index].tarif = parseFloat(harga);
    },
    onChangeValue({ index, label, $event }) {
      this.bhpList[index][label] = $event;
    },
    getErrorMessage(label, type, event) {
      const message = {
        required: `${label} harus di isi.`,
        minLength: `${label} minimal ${event[type] &&
          event[type].min} karakter.`,
        maxLength: `${label} Maksimal ${event[type] &&
          event[type].max} karakter.`,
        charVal: `Hanya bisa huruf, angka dan -`,
        duplicate: `${label} tidak boleh sama.`,
        duplicateBe: `${label} tidak boleh sama.`
      };

      return message[type];
    },
    setErrorMessage(label, event, message = "") {
      const validation =
        typeof event === "object" ? Object.keys(event.$params) : event;

      validation.every(type => {
        if (!event[type]) {
          message = this.getErrorMessage(label, type, event.$params);
          return false;
        }

        return true;
      });
      return message;
    },
    addBhp() {
      this.$v.$touch();
      this.bhpList.push({
        klinik_id: this.getKlinikId,
        kode_layanan: null,
        kategori_id: 3,
        nama_layanan: null,
        tarif: 0,
        stok: null,
        satuan_id: null,
        note: null,
      });
    },
    removeBhp(index) {
      this.bhpList.splice(index, 1);
    },
    triggerValidation() {
      return new Promise(resolve => {
        this.$watch(
          () => !this.$v.$pending,
          isNotPending => {
            if (isNotPending) {
              resolve(!this.$v.$invalid);
            }
          },
          { immediate: true }
        );
      });
    },
    async getSatuan() {
      try {
        const res = await this.$axios.get(`klinik/satuan/list`);
        const { data, status } = res.data;
        if (status) {
          this.optSatuan = data.map(res => ({
            ...res,
            label: res.label,
            value: res.value
          }));
        }
      } catch (error) {}
    },
    async saveBhp() {
      if (
        this.isTambah ||
        (this.isEdit && this.bhpList[0].kode_layanan !== this.prevKodeBhp) ||
        (this.isEdit && this.bhpList[0].nama_layanan !== this.prevNamaBhp)
      )
        this.$v.$touch();
      await this.triggerValidation();
      this.beingSubmit = true;

      try {
        if (!this.$v.bhpList.$error) {
          let response = this.isTambah
            ? 
            await this.$axios.post(`klinik/bhp`, {
                arr: this.bhpList.map((v) => ({...v, stok: parseInt(v.stok), satuan_id: v.satuan_id != null ? v.satuan_id.value : "" }))
              })
            : await this.$axios.put(
                `klinik/bhp/${this.bhp_id}`,
                {...this.bhpList[0], stok: parseInt(this.bhpList[0].stok), satuan_id: this.bhpList[0].satuan_id.value}
              );
          if (response.data.status) {
            this.$swal({
              title: `Data Berhasil disimpan`,
              type: "success"
            });
            this.$router.push({
              name: "klinik-list-bhp"
            });
          } else {
            throw response.data.message;
          }
        } else {
          let requiredText = document.getElementsByClassName("text-danger");
          if (requiredText.length > 0) {
            for (const required of requiredText) {
              required.previousSibling.focus();
              throw "Silakan cek kembali pengisian data Anda!";
            }
          }
          throw "Silakan cek kembali pengisian data Anda!";
        }
      } catch (error) {
        this.beingSubmit = false;
        this.$swal({
          type: "warning",
          text: `${error}`
        });
      }
    },
    NumbersOnly(evt) {
      evt = (evt) ? evt : window.event;
      let charCode = (evt.which) ? evt.which : evt.keyCode;
      if ((charCode > 31 && (charCode < 48 || charCode > 57)) || charCode === 46) {
        evt.preventDefault();;
      } else {
        if (this.isEdit) {
          this.bhpList[0].stok = this.bhpList[0].stok.replace(/-/g,'')
        }
        return true;
      }
    },
    enableEdit(){
      this.$swal({
          title: "Ubah Stok",
          html: `Apakah Anda yakin akan mengubah stok? <br/> Perubahan stok akan mempengaruhi pelaporan.`,
          type: "warning",
          showCancelButton: true,
          cancelButtonText: "Tidak",
          confirmButtonText: "Ya",
        }).then(res => {
          if (res.value) {
            this.stockIsEdit = true;
          }
        });
    }
  }
};
</script>
<style>
.custom-breadcrumb div.row ol.breadcrumb li.breadcrumb-item.active {
  text-transform: capitalize !important;
}
</style>

<style lang="css" scoped>
.required:after {
  content: " *";
  color: red;
  padding-left: 5px;
}

.layout-gantung {
  border-radius: 0px 0px 10px 10px;
  max-height: 250px;
}

.ninja-shadow {
  box-shadow: 0px 8px 15px 0px lightgrey;
}
.__zoom_display {
  zoom: 80%;
}

#inline-form-input-kode,
#inline-form-input-tarif {
  width: 70%;
}

.outer-bhp {
  position: relative;
  border-radius: 15px;
  border: 2px solid #bfbfbf;
  outline-color: #bfbfbf;
  padding: 15px;
  outline-width: thin;
}

.form-inline label {
  display: -moz-box;
  display: flex;
  -moz-box-align: center;
  align-items: center;
  -moz-box-pack: center;
  justify-content: flex-start;
  margin-bottom: 0;
}

.invalid-feedback {
  margin-left: 150px !important;
  color: #f83245 !important;
}

@media screen and (max-width: 767px) {
  #inline-form-input-kode,
  #inline-form-input-tarif {
    width: 100%;
  }
}
</style>
